import React, { useState } from 'react';

const Subscribe = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = () => {
    alert(`Subscribed: ${email}`);
    setEmail('');
  };

  return (
    <section className="subscribe-hero my-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 text-white">
            <h3 className="fw-bold mb-4 display-6">Subscribe for shipping announcements</h3>
            <p className="lead mb-0">Get notified when space becomes available</p>
          </div>
          <div className="col-lg-4">
            <div className="input-group">
              <input 
                type="email"  style={{borderRadius:'0px'}}
                className="form-control form-large subscribe-input" 
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="btn btn-primary book-main-btns w-100 mt-3 mt-lg-0" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscribe;
